<template>
  <svg viewBox="0 0 115 51" class="logo">
    <polygon points="51.7,23 51.9,23.4 55.3,23.4 55,22.5" />
    <polygon points="54.5,21.3 51.2,21.8 51.4,22.3 54.7,21.8" />
    <polygon points="56.5,23.4 59.8,23.4 59.8,21.8 56.5,22.3" />
    <polygon points="53.9,20.1 50.7,20.6 50.9,21.1 54.2,20.6" />
    <polygon points="53.4,18.8 50.2,19.4 50.4,19.9 53.6,19.4" />
    <polygon points="58.9,0.2 56.5,0.2 56.5,16.3 59.8,15.8 59.8,6.3 66.7,14.7 70.3,14.1" />
    <polygon points="56.5,17.6 59.8,17.1 59.8,16.6 56.5,17.1" />
    <polygon points="56.5,18.9 59.8,18.4 59.8,17.8 56.5,18.4" />
    <polygon points="56.5,21.5 59.8,21 59.8,20.4 56.5,21" />
    <polygon points="56.5,20.2 59.8,19.7 59.8,19.1 56.5,19.7" />
    <polygon points="70.8,14.8 67.2,15.4 67.6,15.8 71.2,15.3" />
    <path d="M26.8,23.4c1.9,0,3.2-0.4,4.3-1l-6.5,1H26.8z" />
    <polygon points="52.9,17.6 49.7,18.2 49.9,18.6 53.1,18.1" />
    <path d="M30.7,10.4c1.1-1,1.8-2.6,1.8-4.1c0-1.7-0.7-3.3-1.9-4.4c-1.1-1-2.5-1.6-4.8-1.6h-7.9v23.2h1.9l12.6-2
      c1.3-1.3,2.1-3,2.1-4.9C34.5,13.8,32.9,11.4,30.7,10.4z M21.2,3.3h4c1.9,0,2.7,0.4,3.2,1c0.5,0.5,0.8,1.2,0.8,2
      c0,0.8-0.3,1.5-0.8,2c-0.5,0.6-1.3,1-3.2,1h-4V3.3z M30.1,19.1c-0.7,0.7-1.7,1.2-3.8,1.2h-5v-7.8h5c2.1,0,3.1,0.5,3.8,1.2
      c0.7,0.7,1.1,1.6,1.1,2.7C31.2,17.4,30.7,18.4,30.1,19.1z" />
    <polygon points="34.7,21 38.4,20.5 38.6,19.9 35,20.5" />
    <path d="M45.7,0.2h-2.3l-8.1,19.5l3.7-0.6l0,0l10.4-1.7l0,0l3.2-0.5L45.7,0.2z M40.3,15.9l4.2-10.3l3.7,8.9L40.3,15.9z" />
    <polygon points="33.8,23.4 36.3,23.4 37.3,23.3 37.5,22.7 33.8,23.3" />
    <polygon points="34.1,22.4 37.8,21.9 38.1,21.3 34.4,21.9" />
    <polygon points="86.5,12.8 89.9,12.3 89.9,11.8 86.5,12.3" />
    <path d="M29.1,38.7c1.3-1.1,2.2-2.7,2.2-4.5c0-1.8-0.8-3.5-2.2-4.5c-1-0.8-2.3-1.3-4.3-1.3l-7.7,0l0,22h3.1l0-10.4l2.5,0l7.8,10.4
      l3.8,0l-7.9-10.5C27.6,39.7,28.4,39.3,29.1,38.7z M20.3,37l0-5.7h4.4c1.4,0,2.1,0.3,2.6,0.8c0.5,0.5,0.8,1.2,0.8,2
      c0,0.8-0.3,1.5-0.8,2c-0.5,0.5-1.2,0.8-2.6,0.8L20.3,37L20.3,37z" />
    <path d="M114.1,10.4L114,9.9l0.6-0.1c-0.2-0.9-0.4-1.7-0.7-2.5l-0.5,0.2l-0.2-0.5l0.5-0.2c-0.4-0.8-0.8-1.5-1.3-2.2l-0.5,0.4
      l-0.3-0.4l0.5-0.4c-0.6-0.7-1.2-1.3-1.9-1.8L109.8,3l-0.4-0.3l0.4-0.6c-0.7-0.5-1.5-0.9-2.3-1.3l-0.3,0.7l-0.5-0.2l0.3-0.7
      c-0.8-0.3-1.7-0.5-2.5-0.6l-0.1,0.7l-0.5-0.1L104,0c-0.8-0.1-1.7,0-2.6,0.1l0.1,0.7L101,0.9l-0.1-0.7C100,0.4,99.2,0.6,98.4,1
      l0.3,0.6l-0.5,0.2L98,1.2c-0.8,0.4-1.5,0.8-2.2,1.4l0.4,0.5l-0.4,0.3l-0.4-0.5c-0.6,0.6-1.2,1.2-1.7,1.9l0.5,0.3l-0.3,0.4l-0.4-0.3
      c-0.5,0.7-0.8,1.5-1.1,2.3l0.4,0.2l-0.2,0.5L92.1,8c-0.3,0.9-0.5,1.8-0.5,2.8l3.4-0.5c0.6-3.6,3.1-6.4,6.8-7
      c4.7-0.8,8.8,2.4,9.6,7.4c0.8,5-2.1,9.2-6.8,10c-3.7,0.6-7.1-1.3-8.7-4.6l-3.4,0.5c0.4,0.9,0.8,1.7,1.3,2.5l0.4-0.3l0.3,0.4
      l-0.4,0.3c0.5,0.7,1.1,1.3,1.8,1.8l0.4-0.5l0.4,0.3l-0.4,0.5c0.7,0.5,1.4,1,2.2,1.3l0.3-0.7l0.5,0.2L99,23.1
      c0.8,0.3,1.7,0.5,2.5,0.6l0.1-0.8l0.5,0.1l-0.1,0.8c0.9,0.1,1.7,0.1,2.6-0.1l-0.1-0.8l0.5-0.1l0.1,0.8c0.9-0.2,1.7-0.4,2.5-0.7
      l-0.4-0.8l0.5-0.2l0.4,0.8c0.8-0.4,1.6-0.8,2.3-1.4l-0.6-0.7l0.4-0.3l0.6,0.7c0.7-0.6,1.3-1.2,1.8-1.9l-0.7-0.5l0.3-0.4l0.7,0.5
      c0.5-0.7,0.9-1.5,1.2-2.3l-0.7-0.3l0.2-0.5l0.7,0.3c0.3-0.8,0.4-1.7,0.5-2.5l-0.6-0.1l0.1-0.5l0.6,0.1c0-0.8,0-1.7-0.1-2.6
      L114.1,10.4z" />
    <path d="M13,29.8c-1.1-0.9-2.4-1.4-4.6-1.4l-8.3,0l0,22h3.1l0-9.7l5.2,0c2.1,0,3.5-0.5,4.6-1.4c1.3-1.1,2.2-2.8,2.2-4.7
      C15.2,32.6,14.3,30.9,13,29.8z M11.1,36.7c-0.6,0.6-1.4,1-2.9,1l-5,0l0-6.3h5c1.5,0,2.3,0.4,2.9,1c0.5,0.6,0.9,1.3,0.9,2.2
      C12,35.3,11.7,36.1,11.1,36.7z" />
    <path d="M95.4,14.8L92,15.4c0.1,0.2,0.1,0.3,0.2,0.5l3.3-0.5C95.5,15.2,95.4,15,95.4,14.8z" />
    <path d="M95,13.6l-3.3,0.5c0,0.2,0.1,0.3,0.1,0.5l3.3-0.5C95.1,13.9,95.1,13.8,95,13.6z" />
    <path d="M94.9,12.3l-3.3,0.5c0,0.2,0,0.4,0.1,0.5l3.3-0.5C94.9,12.7,94.9,12.5,94.9,12.3z" />
    <path d="M94.9,11l-3.3,0.5c0,0.2,0,0.4,0,0.5l3.3-0.5C94.9,11.4,94.9,11.2,94.9,11z" />
    <path d="M44.1,28c-6.2,0-11,4.9-11,11.3c0,6.4,4.8,11.3,11,11.3c6.2,0,11-4.9,11-11.3C55.1,32.9,50.3,28,44.1,28z M44.1,47.7
      c-4.5,0-7.9-3.6-7.9-8.3c0-4.7,3.4-8.3,7.9-8.3c4.5,0,7.9,3.6,7.9,8.3C52,44.1,48.6,47.7,44.1,47.7z" />
    <polygon points="71.8,16 68.2,16.5 68.6,17 72.1,16.4" />
    <path d="M61.9,44c0,1.3-0.2,2-0.6,2.5c-0.5,0.7-1.5,1.2-2.5,1.2c-1.3,0-2.4-0.7-2.9-1.7c-0.5,1-1.2,1.8-2,2.5
      c1.1,1.4,2.9,2.2,4.9,2.2c2.3,0,4.4-1.3,5.5-3.2c0.5-0.9,0.8-2,0.8-3.7l0-15.4l-3.1,0L61.9,44L61.9,44z" />
    <polygon points="71.3,40 78.5,40 78.5,37 71.3,37 71.3,31.3 80.7,31.3 80.7,28.4 68.2,28.4 68.2,50.3 81,50.3 81,47.4 71.3,47.4
      " />
    <polygon points="72.8,16.3 76.1,15.8 76.1,15.3 72.8,15.8" />
    <polygon points="72.8,17.2 72.7,17.1 69.1,17.7 69.5,18.2 76.1,17.1 76.1,16.6 72.8,17.1" />
    <polygon points="86.5,11.5 89.9,11 89.9,0.2 86.5,0.2" />
    <polygon points="70.4,19.3 76.1,18.4 76.1,17.9 70.1,18.8" />
    <polygon points="72.8,15 76.1,14.5 76.1,14 72.8,14.5" />
    <polygon points="73.8,23.4 76.1,23.4 76.1,19.2 71,20" />
    <polygon points="86.5,14.2 89.9,13.6 89.9,13.1 86.5,13.6" />
    <polygon points="72.8,13.7 76.1,13.2 76.1,0.2 72.8,0.2" />
    <polygon points="86.5,15.5 89.9,14.9 89.9,14.4 86.5,14.9" />
    <path d="M85.9,19.3c-0.6,0.8-1.6,1.3-2.6,1.3c-1,0-1.9-0.4-2.5-1l-3.5,0.5c1,2.3,3.3,3.6,6,3.6c2.5,0,4.6-1.4,5.8-3.4
      c0.5-0.9,0.7-1.9,0.8-3.4l-3.3,0.5C86.4,18.4,86.2,18.9,85.9,19.3z" />
    <path d="M86.5,16.7c0,0,0,0.1,0,0.1l3.3-0.5v-0.5l-3.3,0.5L86.5,16.7L86.5,16.7z" />
    <polygon points="99.8,28.7 99.8,31.7 105.8,31.7 105.8,50.7 109,50.7 109,31.7 114.9,31.7 114.9,28.7" />
    <path d="M97.8,45.7c-1.3,1.2-3.1,2.3-5.6,2.3c-4.7,0-8.3-3.4-8.3-8.3c0-4.7,3.5-8.3,8-8.3c2.3,0,4.6,1,5.9,2.4V30
      c-1.7-1-3.7-1.6-5.9-1.6c-6.3,0-11.1,5-11.1,11.3c0,6.5,4.8,11.3,11.4,11.3c2,0,3.9-0.6,5.6-1.5L97.8,45.7L97.8,45.7z" />
    <g>
      <polygon points="5.7,4.9 5.7,1.4 4.3,1.4 4.3,4.9 1.5,4.9 1.5,0.3 0.1,0.3 0.1,6.4 10.8,6.4 10.8,0.2 9.3,0.2 9.3,4.9" />
      <polygon points="1.5,23.4 1.5,20.5 10.8,20.5 10.8,19 1.5,19 1.5,16.1 0.1,16.1 0.1,23.4" />
      <polygon points="4.3,9.3 4.3,13.4 0.1,13.4 0.1,14.9 10.8,14.9 10.8,13.4 5.8,13.4 5.8,9.3 10.8,9.3 10.8,7.8 0.1,7.8 0.1,9.3
        " />
    </g>
  </svg>
</template>

<!--/////////////////////////////////////////////////////////////////////////-->

<script>
export default {
  name: 'logo'
}
</script>

<!--/////////////////////////////////////////////////////////////////////////-->

<style scoped lang="scss">
svg {
  fill: currentColor;
}
</style>
